import enUS from 'date-fns/locale/en-US';
import fr from 'date-fns/locale/fr-CA';

export const Locales = {
  en: enUS,
  fr,
};
